module.exports = __webpack_public_path__ + "img/ashley-morey.4812f47c.jpg";